import React, { useState, useEffect, useCallback } from 'react';

const API = 'https://api.botanix.in/api';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#162A40',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#22C55E', blue:'#FFFFFF',
 red:'#EF4444', redBg:'rgba(239,68,68,.10)', redBorder:'rgba(239,68,68,.25)',
 amber:'#F59E0B', amberBg:'rgba(245,158,11,.10)', amberBorder:'rgba(245,158,11,.25)',
};

const inr = n => '₹' + Number(n||0).toLocaleString('en-IN',{maximumFractionDigits:0});
const inp = { width:'100%', padding:'10px 12px', background:'rgba(255,255,255,.05)', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text, fontSize:13, boxSizing:'border-box', outline:'none', fontFamily:'Inter,sans-serif' };
const sel = { ...inp, cursor:'pointer' };

// ── CURRENT RATES TAB ─────────────────────────────────────────────────────────
function CurrentRatesTab() {
 const [rates, setRates] = useState([]);
 const [loading, setLoading] = useState(true);
 const [checkIn, setCheckIn] = useState(new Date().toISOString().slice(0,10));
 const [nights, setNights] = useState(1);
 const [editRate, setEditRate] = useState(null);
 const [newRate, setNewRate] = useState('');
 const [saving, setSaving] = useState(false);

 const load = useCallback(async () => {
 setLoading(true);
 try {
 const r = await fetch(`${API}/pricing/current-rates`).then(x=>x.json());
 setRates(Array.isArray(r)?r:[]);
 } catch {}
 finally { setLoading(false); }
 }, []);

 useEffect(() => { load(); }, [load]);

 const handleSaveRate = async () => {
 if (!newRate || !editRate) return;
 setSaving(true);
 try {
 await fetch(`${API}/rooms/types/${editRate.room_type_id}`, {
 method:'PUT', headers:{'Content-Type':'application/json'},
 body: JSON.stringify({ base_tariff: parseFloat(newRate) }),
 });
 setEditRate(null); setNewRate(''); load();
 } catch(e) { alert('Save failed: '+e.message); }
 finally { setSaving(false); }
 };

 const dayOfWeek = new Date(checkIn).getDay();
 const isWeekend = dayOfWeek === 5 || dayOfWeek === 6;

 return (
 <div>
 {/* Date selector */}
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, padding:18, marginBottom:20 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:14 }}> Check Rates for Date</div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr auto', gap:14, alignItems:'flex-end' }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Check-in Date</label>
 <input style={inp} type="date" value={checkIn} onChange={e=>setCheckIn(e.target.value)} />
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Nights</label>
 <input style={inp} type="number" min={1} value={nights} onChange={e=>setNights(parseInt(e.target.value)||1)} />
 </div>
 <button onClick={load} style={{ padding:'10px 18px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:600 }}>Calculate</button>
 </div>
 {isWeekend && (
 <div style={{ marginTop:12, padding:'8px 14px', background:C.amberBg, border:`1px solid ${C.amberBorder}`, borderRadius:8, color:C.amber, fontSize:13 }}>
 Weekend pricing applies — surcharge active
 </div>
 )}
 </div>

 {loading && <div style={{ textAlign:'center', padding:40, color:C.text2 }}>Loading rates…</div>}

 {!loading && (
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))', gap:14 }}>
 {rates.map(r => {
 const todayRate = isWeekend ? Math.round(r.base_rate * 1.2) : r.base_rate;
 const totalRate = todayRate * nights;
 return (
 <div key={r.room_type_id} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, padding:18 }}>
 <div style={{ fontWeight:800, fontSize:15, color:C.text, marginBottom:4 }}>{r.room_type}</div>
 <div style={{ fontSize:12, color:C.text3, marginBottom:14 }}>Per night rate</div>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', marginBottom:10 }}>
 <div>
 <div style={{ fontSize:11, color:C.text3 }}>Base Rate</div>
 <div style={{ fontSize:14, color:C.text2, textDecoration:isWeekend?'line-through':'none' }}>{inr(r.base_rate)}</div>
 </div>
 <div style={{ textAlign:'right' }}>
 <div style={{ fontSize:11, color:C.text3 }}>Tonight's Rate</div>
 <div style={{ fontSize:22, fontWeight:900, color:isWeekend?C.amber:C.accent }}>{inr(todayRate)}</div>
 </div>
 </div>
 {isWeekend && <div style={{ fontSize:11, color:C.amber, marginBottom:10 }}>+20% weekend surcharge applied</div>}
 <div style={{ background:C.surface2, borderRadius:8, padding:'10px 12px', display:'flex', justifyContent:'space-between', marginBottom:10 }}>
 <span style={{ fontSize:12, color:C.text2 }}>{nights} night{nights>1?'s':''} total</span>
 <span style={{ fontSize:14, fontWeight:800, color:C.accent }}>{inr(totalRate)}</span>
 </div>
 <button onClick={()=>{ setEditRate(r); setNewRate(r.base_rate); }}
 style={{ width:'100%', padding:'7px', background:'rgba(34,197,94,.15)', border:'1px solid rgba(34,197,94,.3)', borderRadius:7, color:'#22C55E', cursor:'pointer', fontSize:12, fontWeight:600 }}>
 Edit Base Rate
 </button>
 </div>
 );
 })}
 </div>
 )}

 {/* Edit Rate Modal */}
 {editRate && (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.75)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center' }}>
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, padding:24, width:360 }}>
 <div style={{ fontWeight:700, fontSize:15, color:C.text, marginBottom:6 }}>Edit Base Rate</div>
 <div style={{ fontSize:13, color:C.text2, marginBottom:16 }}>{editRate.room_type}</div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600, textTransform:'uppercase' }}>New Base Rate (₹ per night)</label>
 <input type="number" value={newRate} onChange={e=>setNewRate(e.target.value)}
 style={{ ...inp, marginBottom:16, fontSize:18, fontWeight:700 }} />
 <div style={{ display:'flex', gap:10 }}>
 <button onClick={()=>{ setEditRate(null); setNewRate(''); }}
 style={{ flex:1, padding:'10px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={handleSaveRate} disabled={saving}
 style={{ flex:1, padding:'10px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700, opacity:saving?.6:1 }}>
 {saving?'Saving…':'Save Rate'}
 </button>
 </div>
 </div>
 </div>
 )}
 </div>
 );
}

// ── PRICING RULES TAB ─────────────────────────────────────────────────────────
function PricingRulesTab() {
 const [rules, setRules] = useState([]);
 const [roomTypes, setRoomTypes] = useState([]);
 const [loading, setLoading] = useState(true);
 const [showForm, setShowForm] = useState(false);
 const [editRule, setEditRule] = useState(null);
 const [saving, setSaving] = useState(false);
 const [form, setForm] = useState({
 rule_name:'', rule_type:'weekend', room_type_id:'', adjustment_type:'percentage',
 adjustment_value:0, start_date:'', end_date:'', days_of_week:'', min_occupancy_pct:'',
 max_occupancy_pct:'', advance_days_min:'', advance_days_max:'', min_rate:'', max_rate:'',
 is_active:true, priority:1,
 });

 const load = useCallback(async () => {
 setLoading(true);
 try {
 const [r, rt] = await Promise.all([
 fetch(`${API}/pricing/rules`).then(x=>x.json()),
 fetch(`${API}/rooms/types`).then(x=>x.json()),
 ]);
 setRules(Array.isArray(r)?r:[]);
 setRoomTypes(Array.isArray(rt)?rt:[]);
 } catch {}
 finally { setLoading(false); }
 }, []);

 useEffect(() => { load(); }, [load]);

 const handleSave = async () => {
 setSaving(true);
 try {
 const url = editRule ? `${API}/pricing/rules/${editRule.id}` : `${API}/pricing/rules`;
 const method = editRule ? 'PUT' : 'POST';
 await fetch(url,{method,headers:{'Content-Type':'application/json'},body:JSON.stringify(form)});
 setShowForm(false); setEditRule(null); load();
 } catch {}
 finally { setSaving(false); }
 };

 const openEdit = (rule) => {
 setEditRule(rule);
 setForm({ ...rule, room_type_id: rule.room_type_id||'', days_of_week: rule.days_of_week||'', start_date: rule.start_date?.slice(0,10)||'', end_date: rule.end_date?.slice(0,10)||'' });
 setShowForm(true);
 };

 const handleDelete = async (id) => {
 if (!window.confirm('Delete this rule?')) return;
 await fetch(`${API}/pricing/rules/${id}`,{method:'DELETE'});
 load();
 };

 const RULE_TYPES = ['weekend','seasonal','early_bird','last_minute','occupancy','group','corporate'];
 const RULE_ICONS = { weekend:'', seasonal:'', early_bird:'', last_minute:'', occupancy:'', group:'', corporate:'' };

 const set = k => e => setForm(p=>({...p,[k]:e.target.value}));

 return (
 <div>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
 <div style={{ fontSize:13, color:C.text2 }}>{rules.length} pricing rules configured</div>
 <button onClick={()=>{ setEditRule(null); setForm({rule_name:'',rule_type:'weekend',room_type_id:'',adjustment_type:'percentage',adjustment_value:0,start_date:'',end_date:'',days_of_week:'',min_occupancy_pct:'',max_occupancy_pct:'',advance_days_min:'',advance_days_max:'',min_rate:'',max_rate:'',is_active:true,priority:1}); setShowForm(true); }}
 style={{ padding:'9px 18px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:700 }}>+ Add Rule</button>
 </div>

 {loading && <div style={{ textAlign:'center', padding:40, color:C.text2 }}>Loading…</div>}

 {!loading && (
 <div style={{ display:'grid', gap:10 }}>
 {rules.length===0 && <div style={{ textAlign:'center', padding:40, color:C.text2, background:C.surface, borderRadius:12 }}>No pricing rules yet. Add rules to enable dynamic pricing!</div>}
 {rules.map(rule=>(
 <div key={rule.id} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, padding:16, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
 <div style={{ display:'flex', gap:14, alignItems:'center' }}>
 <div style={{ width:40, height:40, borderRadius:10, background:`${C.accent}15`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:18 }}>
 {RULE_ICONS[rule.rule_type]||''}
 </div>
 <div>
 <div style={{ fontWeight:700, fontSize:14, color:C.text }}>{rule.rule_name}</div>
 <div style={{ fontSize:12, color:C.text2, marginTop:2 }}>
 {RULE_ICONS[rule.rule_type]} {rule.rule_name} · Priority {rule.priority}
 {rule.days_of_week && ` · Days: ${rule.days_of_week.split(',').map(d=>['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][d]).join(', ')}`}
 </div>
 </div>
 </div>
 <div style={{ display:'flex', gap:10, alignItems:'center' }}>
 <div style={{ textAlign:'right' }}>
 <div style={{ fontSize:18, fontWeight:800, color:parseFloat(rule.adjustment_value)>0?C.amber:C.accent }}>
 {parseFloat(rule.adjustment_value)>0?'+':''}{rule.adjustment_value}%
 </div>
 <div style={{ fontSize:11, color:C.text3 }}>{rule.adjustment_type}</div>
 </div>
 <span style={{ padding:'3px 10px', borderRadius:99, fontSize:11, fontWeight:700, background:rule.is_active?`${C.accent}20`:C.redBg, color:rule.is_active?C.accent:C.red }}>
 {rule.is_active?' On':'Off'}
 </span>
 <button onClick={()=>openEdit(rule)} style={{ padding:'6px 12px', background:'rgba(255,255,255,.06)', border:`1px solid ${C.border}`, borderRadius:6, color:C.text2, cursor:'pointer', fontSize:12 }}></button>
 <button onClick={()=>handleDelete(rule.id)} style={{ padding:'6px 10px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:6, color:C.red, cursor:'pointer', fontSize:12 }}></button>
 </div>
 </div>
 ))}
 </div>
 )}

 {/* Add/Edit Rule Form */}
 {showForm && (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.75)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:16, padding:24, width:'100%', maxWidth:520, maxHeight:'85vh', overflowY:'auto' }}>
 <div style={{ fontWeight:700, fontSize:16, color:C.text, marginBottom:20 }}>{editRule?'Edit':'Add'} Pricing Rule</div>
 <div style={{ display:'grid', gap:14 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Rule Name *</label>
 <input style={inp} value={form.rule_name} onChange={set('rule_name')} placeholder="e.g. Weekend Surcharge" />
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Rule Type</label>
 <select style={sel} value={form.rule_type} onChange={set('rule_type')}>
 {RULE_TYPES.map(t=><option key={t} style={{background:'#0F2040',color:'#F0F2FF'}}>{t}</option>)}
 </select>
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Room Type</label>
 <select style={sel} value={form.room_type_id} onChange={set('room_type_id')}>
 <option value="" style={{background:'#0F2040',color:'#F0F2FF'}}>All Room Types</option>
 {roomTypes.map(rt=><option key={rt.id} value={rt.id} style={{background:'#0F2040',color:'#F0F2FF'}}>{rt.name}</option>)}
 </select>
 </div>
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Adjustment Type</label>
 <select style={sel} value={form.adjustment_type} onChange={set('adjustment_type')}>
 <option style={{background:'#0F2040',color:'#F0F2FF'}}>percentage</option>
 <option style={{background:'#0F2040',color:'#F0F2FF'}}>fixed</option>
 </select>
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Value (use - for discount)</label>
 <input style={inp} type="number" value={form.adjustment_value} onChange={set('adjustment_value')} placeholder="e.g. 20 or -10" />
 </div>
 </div>
 {form.rule_type==='weekend' && (
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Days of Week (0=Sun, 5=Fri, 6=Sat)</label>
 <input style={inp} value={form.days_of_week} onChange={set('days_of_week')} placeholder="5,6" />
 </div>
 )}
 {(form.rule_type==='seasonal') && (
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Start Date</label>
 <input style={inp} type="date" value={form.start_date} onChange={set('start_date')} />
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>End Date</label>
 <input style={inp} type="date" value={form.end_date} onChange={set('end_date')} />
 </div>
 </div>
 )}
 {form.rule_type==='early_bird' && (
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Min Days in Advance</label>
 <input style={inp} type="number" value={form.advance_days_min} onChange={set('advance_days_min')} placeholder="e.g. 30" />
 </div>
 )}
 {form.rule_type==='last_minute' && (
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Max Days in Advance</label>
 <input style={inp} type="number" value={form.advance_days_max} onChange={set('advance_days_max')} placeholder="e.g. 3" />
 </div>
 )}
 <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Priority</label>
 <input style={inp} type="number" value={form.priority} onChange={set('priority')} min={1} />
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Min Rate (₹)</label>
 <input style={inp} type="number" value={form.min_rate} onChange={set('min_rate')} placeholder="Optional" />
 </div>
 <div>
 <label style={{ display:'block', fontSize:12, color:C.text2, marginBottom:5, fontWeight:600 }}>Max Rate (₹)</label>
 <input style={inp} type="number" value={form.max_rate} onChange={set('max_rate')} placeholder="Optional" />
 </div>
 </div>
 <div style={{ display:'flex', alignItems:'center', gap:10 }}>
 <input type="checkbox" checked={form.is_active} onChange={e=>setForm(p=>({...p,is_active:e.target.checked}))} style={{ width:16, height:16, cursor:'pointer', accentColor:C.accent }} />
 <label style={{ fontSize:13, color:C.text, cursor:'pointer' }}>Rule is Active</label>
 </div>
 </div>
 <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:20 }}>
 <button onClick={()=>{setShowForm(false);setEditRule(null);}} style={{ padding:'10px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>Cancel</button>
 <button onClick={handleSave} disabled={saving} style={{ padding:'10px 24px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontWeight:700, opacity:saving?.6:1 }}>
 {saving?'Saving…':editRule?'Update Rule':'Add Rule'}
 </button>
 </div>
 </div>
 </div>
 )}
 </div>
 );
}

// ── RATE CALENDAR TAB ─────────────────────────────────────────────────────────
function RateCalendarTab() {
 const [month, setMonth] = useState(new Date().getMonth());
 const [year, setYear] = useState(new Date().getFullYear());
 const [rates, setRates] = useState([]);

 useEffect(() => {
 fetch(`${API}/pricing/current-rates`).then(r=>r.json()).then(d=>setRates(Array.isArray(d)?d:[])).catch(()=>{});
 }, []);

 const daysInMonth = new Date(year, month+1, 0).getDate();
 const firstDay = new Date(year, month, 1).getDay();
 const days = Array.from({length:daysInMonth},(_,i)=>i+1);
 const baseRate = rates[0]?.base_rate || 7499;

 const getRateForDay = (day) => {
 const d = new Date(year, month, day);
 const dow = d.getDay();
 return dow===5||dow===6 ? Math.round(baseRate*1.2) : baseRate;
 };

 return (
 <div>
 <div style={{ display:'flex', gap:10, alignItems:'center', marginBottom:20 }}>
 <button onClick={()=>{ if(month===0){setMonth(11);setYear(y=>y-1);}else setMonth(m=>m-1); }}
 style={{ padding:'8px 14px', background:C.surface, border:`1px solid ${C.border}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>←</button>
 <div style={{ fontWeight:700, fontSize:16, color:C.text, flex:1, textAlign:'center' }}>
 {new Date(year,month).toLocaleString('en-IN',{month:'long',year:'numeric'})}
 </div>
 <button onClick={()=>{ if(month===11){setMonth(0);setYear(y=>y+1);}else setMonth(m=>m+1); }}
 style={{ padding:'8px 14px', background:C.surface, border:`1px solid ${C.border}`, borderRadius:8, color:C.text2, cursor:'pointer' }}>→</button>
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(7,1fr)', gap:4 }}>
 {['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].map(d=>(
 <div key={d} style={{ textAlign:'center', fontSize:11, color:C.text3, fontWeight:700, padding:'6px 0' }}>{d}</div>
 ))}
 {Array.from({length:firstDay}).map((_,i)=><div key={`e${i}`} />)}
 {days.map(day=>{
 const rate = getRateForDay(day);
 const dow = new Date(year,month,day).getDay();
 const isWE = dow===5||dow===6;
 const isToday = new Date().toDateString()===new Date(year,month,day).toDateString();
 return (
 <div key={day} style={{ background:isWE?C.amberBg:C.surface, border:`1px solid ${isToday?C.accent:isWE?C.amberBorder:C.border}`, borderRadius:8, padding:8, textAlign:'center' }}>
 <div style={{ fontSize:12, color:isToday?C.accent:C.text, fontWeight:isToday?800:400 }}>{day}</div>
 <div style={{ fontSize:11, color:isWE?C.amber:C.accent, fontWeight:600 }}>{inr(rate)}</div>
 </div>
 );
 })}
 </div>
 <div style={{ display:'flex', gap:16, marginTop:16, fontSize:12, color:C.text2 }}>
 <span> <span style={{color:C.accent}}>Weekday rates</span></span>
 <span> <span style={{color:C.amber}}>Weekend (+20%)</span></span>
 </div>
 </div>
 );
}

// ── OTA CONNECTIONS TAB ───────────────────────────────────────────────────────
function OTATab() {
 const otas = [
 { name:'MakeMyTrip', status:'Not Connected', color:'#E84545', logo:'MMT' },
 { name:'Booking.com', status:'Not Connected', color:'#003580', logo:'BDC' },
 { name:'Expedia', status:'Not Connected', color:'#FFD700', logo:'EXP' },
 { name:'Airbnb', status:'Not Connected', color:'#FF5A5F', logo:'AIR' },
 { name:'Goibibo', status:'Not Connected', color:'#E03040', logo:'GOI' },
 { name:'Agoda', status:'Not Connected', color:'#E03020', logo:'AGO' },
 { name:'Staah', status:'Pending Setup', color:'#F59E0B', logo:'STH' },
 { name:'RateTiger', status:'Pending Setup', color:'#F59E0B', logo:'RT' },
 ];
 return (
 <div>
 <div style={{ background:C.amberBg, border:`1px solid ${C.amberBorder}`, borderRadius:10, padding:14, marginBottom:20, fontSize:13, color:C.amber }}>
 OTA channel manager requires Staah or RateTiger subscription. Contact your OTA specialist to set up channel manager integration.
 </div>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))', gap:12 }}>
 {otas.map(ota=>(
 <div key={ota.name} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:12, padding:16, textAlign:'center' }}>
 <div style={{ width:48, height:48, borderRadius:12, background:`${ota.color}20`, border:`1px solid ${ota.color}44`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:800, color:ota.color, margin:'0 auto 10px' }}>{ota.logo}</div>
 <div style={{ fontWeight:700, fontSize:14, color:C.text, marginBottom:4 }}>{ota.name}</div>
 <span style={{ padding:'3px 10px', borderRadius:99, fontSize:11, fontWeight:600, background:ota.status==='Connected'?`${C.accent}20`:ota.status==='Pending Setup'?C.amberBg:C.redBg, color:ota.status==='Connected'?C.accent:ota.status==='Pending Setup'?C.amber:C.red }}>
 {ota.status}
 </span>
 </div>
 ))}
 </div>
 </div>
 );
}

// ── MAIN DYNAMIC PRICING ──────────────────────────────────────────────────────
export default function DynamicPricing() {
 const [tab, setTab] = useState('rates');

 const TABS = [
 { id:'rates', label:' Current Rates' },
 { id:'rules', label:' Pricing Rules' },
 { id:'calendar',label:' Rate Calendar' },
 { id:'ota', label:' OTA Connections'},
 ];

 return (
 <div style={{ padding:24, background:C.bg, minHeight:'100vh', color:C.text, fontFamily:'Inter,sans-serif' }}>
 <div style={{ marginBottom:24 }}>
 <div style={{ fontSize:22, fontWeight:800, color:C.text }}> Dynamic Pricing Engine</div>
 <div style={{ fontSize:13, color:C.text2, marginTop:2 }}>Smart rate management, pricing rules and OTA connections</div>
 </div>

 {/* Tabs */}
 <div style={{ display:'flex', gap:4, marginBottom:24, background:C.surface, borderRadius:10, padding:4, width:'fit-content' }}>
 {TABS.map(t=>(
 <button key={t.id} onClick={()=>setTab(t.id)}
 style={{ padding:'8px 18px', borderRadius:8, border:'none', cursor:'pointer', fontSize:13, fontWeight:600, background:tab===t.id?C.accent:'transparent', color:tab===t.id?'#fff':C.text2, whiteSpace:'nowrap' }}>
 {t.label}
 </button>
 ))}
 </div>

 {tab==='rates' && <CurrentRatesTab />}
 {tab==='rules' && <PricingRulesTab />}
 {tab==='calendar' && <RateCalendarTab />}
 {tab==='ota' && <OTATab />}
 </div>
 );
}
